import { HoldNodeData } from 'modules/workflows/types';
import {
  CUSTOM_DURATION_VALUE,
  durationOptions,
  DurationOption,
  MAX_DAYS,
} from './HoldDurationSection.constants';

const expireValueNames = ['expireHours', 'expireDays', 'expireMinutes'];

const isCurrentDuration = (optionData: DurationOption['data'], nodeData: Partial<HoldNodeData>) =>
  expireValueNames.every(
    (expireType) => (optionData[expireType] || 0) === (nodeData[expireType] || 0),
  );

const isNotSet = (nodeData: Partial<HoldNodeData>) =>
  expireValueNames.every((expireType) => !nodeData[expireType]);

export const getDefaultDurationValues = (
  nodeData: Partial<HoldNodeData>,
  isCustomEnabled = false,
) => {
  for (let i = 0; i < durationOptions.length; i++) {
    const { data, id } = durationOptions[i];
    if (isCurrentDuration(data, nodeData)) {
      return [id];
    }
  }

  return !isCustomEnabled || isNotSet(nodeData) ? [] : [CUSTOM_DURATION_VALUE];
};

export const validateDuration = ({
  expireDays = 0,
  expireHours = 0,
  expireMinutes = 0,
}: Partial<HoldNodeData>) => {
  return expireDays * 24 * 60 + expireHours * 60 + expireMinutes <= MAX_DAYS * 24 * 60;
};
